module.exports = __webpack_public_path__ + "static/media/insurance1.c623963b.png";